import { type InjectionKey, inject, provide, type Ref, ref } from "vue";

const POOL_EDITOR_AVAILABLE: InjectionKey<Ref<boolean>> = Symbol(
  "poolEditorAvailable"
);

/**
 * Lets a page say whether its pool links may open the pool editor; while they may not, each
 * `PoolLinkComponent` below it shows the pool's name alone.
 */
export const providePoolEditorAvailable = (available: Ref<boolean>) =>
  provide(POOL_EDITOR_AVAILABLE, available);

/** Whether pool links open the pool editor here; true on any page that does not say otherwise. */
export const usePoolEditorAvailable = (): Ref<boolean> =>
  inject(POOL_EDITOR_AVAILABLE, ref(true));
